import { Injectable } from "@angular/core";
import { Angular2Csv } from "angular2-csv/Angular2-csv";

@Injectable()
export class Json2csvService {
    constructor() {}

    export(json: any, name, byUpload: boolean = false): void {
        const self = this;
        const rows = json.map(item => self.buildObject(item, byUpload));
        const options = self.getCsvOptions(rows);
        new Angular2Csv(rows, name, options);
    }

    getCsvOptions(data: any): any {
        return {
          fieldSeparator: ";",
          quoteStrings: "\"",
          decimalseparator: ".",
          showLabels: true,
          showTitle: true,
          title: this.buildHeaders(data),
          useBom: true
        };
      }

    buildObject(obj: any, byUpload: boolean) {
        const result = {};
        if (obj != null && obj != undefined) {
            Object.keys(obj).forEach(property => {
                if (typeof obj[property] == "object") {
                    if (obj[property] != null && obj[property] != undefined) {
                        const subObj = this.buildObject(obj[property], byUpload);
                        Object.keys(subObj).forEach(subProp => {
                            result[`${property}_${subProp}`] = subObj[subProp];
                        });
                    } else {
                        result[property] = "";
                    }
                } else {
                    result[property] = obj[property] ? obj[property].toString() : byUpload ? '' : '-';
                }
            });
        }
        return result;
    }

    buildHeaders(items, prefix?: string): string {
        let result = "";
        if (items.length > 0) {
            const obj = items[0];
            if (obj != null && obj != undefined) {
                const properties = Object.keys(obj);
                for (let index = 0; index < properties.length; index++) {
                    let add = "";
                    const property = properties[index];
                    if (
                        typeof obj[property] == "object" &&
                        obj[property] != null &&
                        obj[property] != undefined
                    ) {
                        add = this.buildHeaders(
                            [obj[property]],
                            prefix ? `${prefix}_${property}` : property
                        );
                    } else {
                        add = prefix ? `${prefix}_${property}` : property;
                    }
                    result += add;
                    if (add != "" && index + 1 != properties.length) {
                        result += ";";
                    }
                }
            }
        }
        return result;
    }
}



// WEBPACK FOOTER //
// ./src/app/services/json2csv.service.ts